<script setup lang="ts">
import { systemVersionDisplay } from '@/lib/utils/systemVersion'
</script>

<template>
  <footer
    class="h-12 px-4 flex items-center justify-end text-xs text-tertiary border-t border-border"
  >
    <span class="font-mono">{{ systemVersionDisplay }}</span>
  </footer>
</template>
